import { FC, useState } from 'react';
import { BillableEvent, Invoice, InvoiceItem } from 'types';
import { BillableEventView, EditAction } from '../enums';
import { BillableEventForm } from './billable-event-form';
import { BillableEventList } from './billable-events-list';

export const EventsView: FC<{
  invoice: Invoice;
  invoiceItem: InvoiceItem;
  setSelectedAction: (action: EditAction | null) => void;
  close: () => void;
  onItemEditSuccess: () => void;
}> = ({ invoiceItem, setSelectedAction, close, onItemEditSuccess, invoice }) => {
  const [view, setView] = useState<BillableEventView>(BillableEventView.LIST);
  const [billableEvent, setBillableEvent] = useState<BillableEvent | undefined>(undefined);

  return (
    <>
      {view === BillableEventView.FORM && (
        <BillableEventForm
          close={close}
          setView={setView}
          existingEvent={billableEvent}
          invoice={invoice}
          invoiceItem={invoiceItem}
          onItemEditSuccess={onItemEditSuccess}
        />
      )}
      {view === BillableEventView.LIST && (
        <BillableEventList
          billableEvents={invoiceItem.billableEvents}
          close={close}
          setSelectedAction={setSelectedAction}
          setView={setView}
          setBillableEvent={setBillableEvent}
          onDelete={onItemEditSuccess}
          invoiceId={invoice.id}
        />
      )}
    </>
  );
};
